declare const TOEGANG_CLIENT_SECRETS: string | undefined;

export const toegangClientSecret = (client: string) => {
  if (typeof TOEGANG_CLIENT_SECRETS === 'undefined') {
    console.warn(
      `TOEGANG_CLIENT_SECRET_${client.toUpperCase()} is not defined. Please set it in your environment variables.`,
    );
    return '';
  }

  const secrets: Record<string, string> = JSON.parse(TOEGANG_CLIENT_SECRETS);
  const secret = secrets[client.toLowerCase()];

  if (!secret) {
    console.warn(
      `TOEGANG_CLIENT_SECRET_${client.toUpperCase()} is not defined. Please set it in your environment variables.`,
    );
    return '';
  }

  return secret;
};
